<template>
  <v-container fluid class="pageContainer">
    <div class="mainContent">
      <v-card>
        <div class="div-buttons">
          <slot name="additionalButtons" />
        </div>
        <v-expansion-panels
          v-if="collapsible"
          :value="opened ? 0 : undefined"
          flat
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <card-header v-if="!!titleBarTitle">
                {{ titleBarTitle }}
              </card-header>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text v-if="$slots.content" class="card-text-padding">
                <slot name="content" />
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
      <v-card v-if="!collapsible">
        <card-header v-if="!!titleBarTitle">
          {{ titleBarTitle }}
        </card-header>
        <v-card-text v-if="$slots.content" class="card-text-padding">
          <slot name="content" />
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import CardHeader from '../CardHeader.vue'

export default defineComponent({
  components: {
    CardHeader,
  },

  props: {
    titleBarTitle: {
      type: String,
      required: false,
      default: '',
    },
    headerAdditionalClass: {
      type: String,
      required: false,
    },
    collapsible: {
      type: Boolean,
      required: false,
    },
    opened: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
})
</script>
<style scoped>
.pageContainer {
  align-items: flex-start;
  flex-direction: column;
}

.container {
  max-width: 100%;
  width: 100%;
  margin-top: 30px;
}

.div-buttons {
  position: absolute;
  right: 30px;
  margin-top: -30px;
  z-index: 4;
}

.card-text-padding {
  padding: 30px 20px 30px 20px;
}
</style>
